import React from 'react';
import { useModal, useModalTitle } from '@topconagriculture/modal';
import { useTranslation } from 'react-i18next';
import { InventoryWidgetL } from '../../InventoryWidgetL';
import { ModalFooter } from './ModalFooter';
import { getInventoryParams } from '../../../../../../utils/utils';
import { useInventorySubscription } from '../../../useInventorySubscription';
import { useRedirect } from '../../../../../../hooks/useRedirect';
export const InventoryWidgetLModal = () => {
    const { modalParams, closeModal } = useModal();
    const { t } = useTranslation();
    const inventory = useInventorySubscription();
    useModalTitle(t('widget:inventory:title'));
    const { viewMoreButtonIsDisabled, includedIngredients } = getInventoryParams(inventory);
    const link = `/inventory/overview?ingredients=${includedIngredients}`;
    const viewMore = useRedirect(link);
    return (React.createElement(React.Fragment, null,
        React.createElement(InventoryWidgetL, { modalParams: modalParams }),
        React.createElement(ModalFooter, { viewMore: viewMore, closeModal: closeModal, disabled: viewMoreButtonIsDisabled })));
};
//# sourceMappingURL=InventoryWidgetLModal.js.map